import { ColumnDef, createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import Device from '../../../shared/models/device.model'
import TenantName from '../../helper/TenantName'
import CustomerName from '../../helper/CustomerName'
import DeviceInfoTools from './DeviceInfoTools'
import { ActionRowProps } from '../../../components/kopiliot-list/type'

const getColumnsForTableDevice = (actionRows: ActionRowProps[]) => {
  const columnHelper = createColumnHelper<Device>()
  const columns: ColumnDef<Device, string>[] = [
    columnHelper.accessor((row) => row.id?.id, {
      id: 'id',
      cell: (info) => info.getValue(),
      header: () => 'Id',
      enableSorting: true,
    }),
    columnHelper.accessor((row) => row.name, {
      id: 'name',
      meta: {
        className: 'align-middle text-primary fw-bold',
      },
      cell: (info) => info.getValue(),
      header: () => 'Name',
      enableSorting: true,
    }),
    columnHelper.accessor((row) => row.description, {
      id: 'description',
      meta: {
        className: 'text-800',
      },
      cell: (info) => info.getValue(),
      header: () => 'Desc',
      enableSorting: false,
    }),
    columnHelper.display({
      id: 'deviceProfile',
      meta: {
        className: 'text-800',
      },
      cell: (props) => {
        return (
          <>
            {props.row.original.id?.id && (
              <DeviceInfoTools.DeviceProfile
                deviceID={props.row.original.id?.id}
              />
            )}
          </>
        )
      },
      header: () => 'Profile',
    }),
    columnHelper.display({
      id: 'enabled',
      maxSize: 50,
      meta: {
        className: 'align-middle text-center',
      },
      cell: (props) => {
        return (
          <>
            {props.row.original.id && (
              <DeviceInfoTools.Status deviceID={props.row.original.id.id} />
            )}
          </>
        )
      },
      header: () => 'Activé',
    }),
    columnHelper.display({
      id: 'isConnected',
      maxSize: 70,
      meta: {
        className: 'align-middle text-center',
      },
      cell: (props) => {
        return (
          <>
            {props.row.original.id && (
              <DeviceInfoTools.IsConnected
                deviceID={props.row.original.id.id}
              />
            )}
          </>
        )
      },
      header: () => 'Connecté',
    }),
    columnHelper.display({
      id: 'lastActivityAt',
      meta: {
        className: 'text-800',
      },
      cell: (props) => {
        return (
          <>
            {props.row.original.id && (
              <DeviceInfoTools.LastActivityAt
                deviceID={props.row.original.id.id}
              />
            )}
          </>
        )
      },
      header: () => 'Der. activité',
    }),
    columnHelper.display({
      id: 'customerID',
      meta: {
        className: 'text-800',
      },
      cell: (props) => {
        return (
          <>
            {props.row.original.customerID && (
              <CustomerName customerId={props.row.original.customerID.id} />
            )}
          </>
        )
      },
      header: () => 'Customer',
    }),
    columnHelper.display({
      id: 'tenantID',
      meta: {
        className: 'text-800',
      },
      cell: (props) => {
        return (
          <>
            <TenantName tenantId={props.row.original.tenantID.id} />
          </>
        )
      },
      header: () => 'Tenant',
    }),
    columnHelper.display({
      id: 'actions',
      maxSize: 40,
      meta: {
        className: 'align-middle py-2',
      },
      cell: (props) => {
        const deviceId = props.row.original.id?.id
        return (
          <>
            {actionRows && deviceId && (
              <Dropdown
                className={'text-center btn-reveal-trigger'}
                onClick={(event) => event.stopPropagation()}
              >
                <Dropdown.Toggle
                  size={'sm'}
                  className={'btn-reveal'}
                  variant="falcon-default"
                  id="dropdown-assets-actions"
                >
                  <FontAwesomeIcon icon={'ellipsis-h'} />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  popperConfig={{ strategy: 'fixed' }}
                  renderOnMount={true}
                >
                  {actionRows.map((item) => {
                    return (
                      <Dropdown.Item
                        className={`text-${item.color || 'primary'}`}
                        key={item.title}
                        onClick={() => {
                          if (item.onClick) {
                            item.onClick(deviceId)
                          }
                        }}
                      >
                        <FontAwesomeIcon
                          icon={item.icon}
                          className="fs-0 me-2"
                        />
                        {item.title}
                      </Dropdown.Item>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </>
        )
      },
    }),
  ]
  return columns
}

const defaultDeviceActionsRow = (
  onDeleteItem: (id: string) => void,
  onEditItem: (id: string) => void
) => {
  const actionsRow: ActionRowProps[] = [
    {
      title: 'Edit',
      color: 'primary',
      icon: 'edit',
      onClick: (id) => {
        onEditItem(id)
      },
    },
    {
      title: 'Delete',
      color: 'danger',
      icon: 'trash-alt',
      onClick: (id) => {
        onDeleteItem(id)
      },
    },
  ]
  return actionsRow
}

export { getColumnsForTableDevice, defaultDeviceActionsRow }
